import { Injectable, inject, Injector } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { select } from '@ngxs/store';
import { take } from 'rxjs';
import {
  AdminRoutesEnum,
  AdminUsersRoutes,
  RoutesEnum,
  UserUsersAndPaxRoutes,
} from 'src/app/core/enums/routes.enum';
import { ToastService } from 'src/app/core/services/toast.service';
import { MenuListLogicService } from 'src/app/core/services/menu-list-logic.service';
import { CompetenceState } from '../../../competence/state/competence.state';
import { UserProfileRoutes } from '../../../core/enums/routes.enum';
import { redirectAndBypassUnsavedDataCheck } from '../../functions/redirect-and-bypass-unsaved-data-check';
import { IdName } from '../../models/id-name';

@Injectable({
  providedIn: 'root',
})
export class CompetenceUserService {
  private readonly injector = inject(Injector);

  private readonly competencesFromStore = select(CompetenceState.getAllCompetences);

  private competences: IdName[];

  constructor(
    private router: Router,
    private translateService: TranslateService,
    private toastService: ToastService,
    private menuListLogicService: MenuListLogicService
  ) {}

  routeToNewCompetence(userId: string, competenceId: string): void {
    this.getCompetences();
    let competenceName = '';
    this.competences.forEach((item: IdName) => {
      if (item.id === competenceId) {
        competenceName = item.name;
      }
    });
    this.toastService.error(
      `${this.translateService.instant('pleaseAddRequiredCompetenceWithName')} ${competenceName}`
    );

    const moduleName = this.router.url;
    let redirectUrl = '';
    if (moduleName.includes(RoutesEnum.Profile)) {
      redirectUrl = `${UserProfileRoutes.CompetenceUserRegister}${userId}/${competenceId}`;
    } else if (moduleName.includes(AdminRoutesEnum.Users)) {
      redirectUrl = `${AdminUsersRoutes.CompetenceUserRegister}${userId}/${competenceId}`;
    }

    redirectAndBypassUnsavedDataCheck(redirectUrl);
  }

  routeBackToUserCompetencesList(userId: string): void {
    const isInAdmin = this.menuListLogicService.isCurrentUrlInAdmin();
    if (isInAdmin) {
      redirectAndBypassUnsavedDataCheck(
        `${AdminUsersRoutes.Users}/${userId}/(detailsOut:competence)`
      );
    } else {
      const url = this.router.url.includes('profile')
        ? `${RoutesEnum.Profile}/view/(details:competence)`
        : `${UserUsersAndPaxRoutes.Users}/${userId}/(detailsOut:competence)`;
      redirectAndBypassUnsavedDataCheck(url);
    }
  }

  private getCompetences(): void {
    toObservable(this.competencesFromStore, { injector: this.injector })
      .pipe(take(1))
      .subscribe((competences: IdName[] | undefined) => {
        if (competences) {
          this.competences = competences;
        }
      });
  }
}
